import { render, staticRenderFns } from "./GroupMember.vue?vue&type=template&id=1f673662"
import script from "./GroupMember.vue?vue&type=script&lang=js"
export * from "./GroupMember.vue?vue&type=script&lang=js"
import style0 from "./GroupMember.vue?vue&type=style&index=0&id=1f673662&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports